module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chris Lloyd\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Chris Lloyd lived in Catalonia for over twenty years, besides brief spells in Bilbao, Madrid, Grenoble and a mill in Devon. He has written and contributed to several travel books about Spain for Rough Guides, travelling extensively around the country. Now back in South Wales, he works as a Catalan and Spanish translator. This is his first novel.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yIKpHL/tc-custom/9781910859933.jpg?1699135512364",
      "alt": "This image is the cover for the book City of Good Death, The Catalan Crime Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("City of Good Death, The Catalan Crime Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("A Catalonian police detective struggles to stop a serial killer targeting unsavory victims in this atmospheric crime thriller series debut.")])]), _c('p', [_vm._v(" A killer is targeting figures of corruption in the Catalan city of Girona, with each corpse posed in a way whose meaning no one can fathom. ")]), _c('p', [_vm._v(" Elisenda Domenech, the head of Girona’s newly-formed Serious Crime Unit, believes the attacker is drawing on the city’s legends to choose his targets, but soon finds her investigation is blocked at every turn. ")]), _c('p', [_vm._v(" Battling against the increasing sympathy towards the killer displayed by the press, the public and even some of the police, she finds herself forced to question her own values. But when the attacks start to include less-deserving victims, the pressure is suddenly on Elisenda to stop him. The question is: how? ")]), _c('b', [_vm._v("Perfect for readers of Val McDermid and the Inspector Montalbano novels.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0